import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root'
})
export class TrackRequestService {
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),

  };
  constructor(private http: HttpClient, private UTS: UtilitiesService) { }

  trackRequest(cqRefNo) {
    const payload = { "cqRefNo": cqRefNo };
    return this.http.post(
      `${environment.BASE_URL}/cqTrackRequest`,
      payload,
      this.httpOptions
    );
  }

  handleCQOperations(payload) {
    return this.http.post(
      `${environment.BASE_URL}/handleCQOperations`,
      payload,
      this.httpOptions
    );
  }



}
